var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { EventsService } from '../events.service';
import moment from 'moment';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { ChangeEmailAddressComponent } from './change-email-address/change-email-address.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material';
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component';
import { MoveTicketDatesComponent } from '../move-ticket-dates/move-ticket-dates.component';
import { of, Subject } from 'rxjs';
import { ChangeBuyerAddressComponent } from '@app/shared/change-buyer-address/change-buyer-address.component';
import { VouchersService } from '@app/vouchers/vouchers.service';
import { catchError, takeUntil } from 'rxjs/operators';
export class OrdersComponent {
    constructor(eventService, modalService, snackBar, voucherService) {
        this.eventService = eventService;
        this.modalService = modalService;
        this.snackBar = snackBar;
        this.voucherService = voucherService;
        this.ngUnsubscribe = new Subject();
        this.ticketOrders = [];
        this.allOrdersCopy = [];
        this.ticketOrdersMobile = [];
        this.loading = true;
        this.expanded = {};
        this.tableLimit = 50;
        this.tablePages = [];
        this.tableOffset = 1;
        this.filterBy = '';
        this.filterId = 0;
        this.myControl = new FormControl();
        this.dates = {
            from: '',
            to: ''
        };
        this.lowValue = 0;
        this.highValue = 50;
        this.pageSize = 50;
        this.amountFilter = '0';
        this.allEvents = [];
        this.filter = {
            eventId: null,
            eventDate: null,
            showAll: false,
            RedemptionDateTicket: false
        };
        this.filterStats = {
            orders: {
                count: 0,
                total: 0
            },
            cancelations: {
                count: 0,
                total: 0
            }
        };
        this.loadingAccountingPDF = false;
    }
    ngOnInit() {
        this.getTransactions(true);
        this.getAllEvents();
    }
    getTransactions(initialStart = false) {
        this.filterStats.orders.total = 0;
        this.filterStats.orders.count = 0;
        this.filterStats.cancelations.total = 0;
        this.filterStats.cancelations.count = 0;
        this.loading = true;
        if (initialStart) {
            this.dates.from = moment()
                .subtract(7, 'days')
                .format('YYYY-MM-DD');
            this.dates.to = moment().format('YYYY-MM-DD');
        }
        this.eventService
            .getTicketOrders(this.dates.from, this.dates.to, this.amountFilter, this.filter)
            .subscribe(orders => {
            orders.map((item, key) => {
                // orders[key].eventName =
                //   item.tickets.length > 0 && item.tickets[0].dateInfo && item.tickets[0].dateInfo.event
                //     ? item.tickets[0].dateInfo.event.name
                //     : '';
                orders[key].eventName =
                    item.tickets.length > 0 &&
                        item.tickets[0] &&
                        item.tickets[0].eventDetails &&
                        item.tickets[0].eventDetails.name
                        ? item.tickets[0].eventDetails.name
                        : '';
                orders[key].eventDate =
                    item.tickets.length > 0 && item.tickets[0].dateInfo
                        ? moment(item.tickets[0].dateInfo.startsAtDay + ' ' + item.tickets[0].dateInfo.startsAtHour).format('DD.MM.YYYY HH:mm')
                        : item.eventDate
                            ? moment(item.eventDate).format('DD.MM.YYYY HH:mm')
                            : '';
                if (item.status === 'canceled') {
                    this.filterStats.cancelations.total += item.subtotal;
                    this.filterStats.cancelations.count += 1;
                }
                else {
                    this.filterStats.orders.total += item.subtotal;
                    this.filterStats.orders.count += 1;
                }
                return orders;
            });
            this.ticketOrders = orders;
            if (this.filterBy && this.filterBy != '') {
                this.allOrdersCopy = [];
                this.filterOrdersBy('client', this.filterBy);
            }
            this.setTablePages();
            this.loading = false;
        });
    }
    setTablePages() {
        this.tablePages = [];
        for (let index = 1; index <= this.ticketOrders.length / this.tableLimit + 1; index++) {
            this.tablePages.push(index);
        }
        const paginateEvent = {
            previousPageIndex: 0,
            pageSize: this.pageSize,
            pageIndex: 0,
            length: this.ticketOrders.length
        };
        this.getPaginatorData(paginateEvent);
        this.loading = false;
    }
    filterOrdersBy(filterBy = '', filterVal = '') {
        switch (filterBy) {
            case 'from':
                this.dates.from = filterVal;
                this.allOrdersCopy = [...this.ticketOrders];
                this.ticketOrders = this.allOrdersCopy.filter(function (order) {
                    if ((order.createdAt >= this.dates.from || this.dates.from == '') &&
                        (order.createdAt <= this.dates.to || this.dates.to == '')) {
                        return order;
                    }
                }, this);
                this.ticketOrders = [...this.ticketOrders];
                this.setTablePages();
                //this.prepareChartData();
                break;
            case 'to':
                this.dates.to = filterVal;
                this.allOrdersCopy = [...this.ticketOrders];
                this.ticketOrders = this.allOrdersCopy.filter(function (order) {
                    if ((order.createdAt >= this.dates.from || this.dates.from == '') &&
                        (order.createdAt <= this.dates.to || this.dates.to == '')) {
                        return order;
                    }
                }, this);
                this.ticketOrders = [...this.ticketOrders];
                this.setTablePages();
                //this.prepareChartData();
                break;
            case 'client':
                filterVal = `${filterVal}`;
                this.filterBy = filterVal;
                if (this.allOrdersCopy.length) {
                    this.ticketOrders = this.allOrdersCopy;
                }
                this.allOrdersCopy = [...this.ticketOrders];
                this.ticketOrders = this.allOrdersCopy.filter(function (order) {
                    if (order && order.firstName.toLowerCase().includes(filterVal.toLowerCase())) {
                        return order;
                    }
                    else if (order && order.lastName.toLowerCase().includes(filterVal.toLowerCase())) {
                        return order;
                    }
                    else if (order && order.client.name.toLowerCase().includes(filterVal.toLowerCase())) {
                        return order;
                    }
                }, this);
                this.ticketOrders = [...this.ticketOrders];
                this.setTablePages();
                // this.table.offset = 0;
                break;
            default:
                this.filterBy = '';
                this.ticketOrders = [...this.allOrdersCopy];
                this.setTablePages();
                this.allOrdersCopy = [];
                break;
        }
    }
    setDates(type) {
        if (type == 'today') {
            this.dates.from = moment().format('YYYY-MM-DD');
            this.dates.to = moment().format('YYYY-MM-DD');
        }
        if (type == 'yesterday') {
            this.dates.from = moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD');
            this.dates.to = moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD');
        }
        if (type == 'thisWeek') {
            const date = moment();
            this.dates.from = date.startOf('week').format('YYYY-MM-DD');
            this.dates.to = moment(this.dates.from)
                .endOf('week')
                .format('YYYY-MM-DD');
        }
        if (type == 'lastSeven') {
            this.dates.from = moment()
                .subtract(6, 'days')
                .format('YYYY-MM-DD');
            this.dates.to = moment().format('YYYY-MM-DD');
        }
        if (type == 'lastWeek') {
            const date = moment().subtract(1, 'week');
            this.dates.from = date.startOf('week').format('YYYY-MM-DD');
            this.dates.to = moment(this.dates.from)
                .endOf('week')
                .format('YYYY-MM-DD');
        }
        if (type == 'lastMonth') {
            const date = moment().subtract(1, 'month');
            this.dates.from = date.startOf('month').format('YYYY-MM-DD');
            this.dates.to = moment(this.dates.from)
                .endOf('month')
                .format('YYYY-MM-DD');
        }
        if (type == 'thisMonth') {
            const date = moment();
            this.dates.from = date.startOf('month').format('YYYY-MM-DD');
            this.dates.to = moment(this.dates.from)
                .endOf('month')
                .format('YYYY-MM-DD');
        }
        this.getTransactions(false);
    }
    toggleExpandRow(row) {
        this.table.rowDetail.toggleExpandRow(row);
    }
    // used to build an array of orders for mobile relevant at any given time
    getPaginatorData(event) {
        this.pageSize = event.pageSize;
        this.lowValue = event.pageIndex * event.pageSize;
        this.highValue = this.lowValue + event.pageSize;
        this.ticketOrdersMobile = this.ticketOrders.slice(this.lowValue, this.highValue);
        return event;
    }
    sendTicketPdf(order) {
        const modalRef = this.modalService.open(ChangeEmailAddressComponent, { windowClass: 'onboarding-modal' });
        modalRef.componentInstance.email = order.email;
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            order.userEmail = receivedEntry.email;
            this.eventService.sendTicketPdf(order).subscribe((result) => {
                this.snackBar.open('Ticket wurde erfolgreich gesendet an ' + order.userEmail + '!', '', {
                    duration: 2000,
                    panelClass: ['snackbar-success']
                });
            }, (err) => {
                console.error(55, err);
                this.snackBar.open('Fehler beim Senden von E-Mails.', '', {
                    duration: 2000,
                    panelClass: ['snackbar-error']
                });
            });
        });
    }
    cancelTicket(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const voucherSettings = yield this.voucherService
                .getSettings()
                .pipe(takeUntil(this.ngUnsubscribe), catchError(err => {
                if (err.status === 400 || err.status === 404) {
                    return of(null);
                }
                throw err;
            }))
                .toPromise();
            const voucherSettingsExists = voucherSettings && voucherSettings.betriebId ? true : false;
            // default
            let refundType = 'voucher';
            let refundContent = 'Der Gast erhält einen Wertgutschein im Gegenwert der/des gekauften Tickets. Es fallen dafür keine Gebühren an.';
            const modalRef = this.modalService.open(ConfirmModalComponent);
            modalRef.componentInstance.title = 'Ticket stornieren';
            modalRef.componentInstance.message = `Sind Sie sicher dass Sie die ticket stornieren möchten?`;
            modalRef.componentInstance.showInfo = false;
            modalRef.componentInstance.buttonText = 'Ja';
            if (voucherSettingsExists) {
                setTimeout(() => {
                    const body = document.querySelector('.modal-body .onboarding-content');
                    if (!body)
                        return;
                    const wrapper = document.createElement('div');
                    wrapper.innerHTML = `
    <div id="refund-wrapper">

      <button id="voucher-btn" data-value="voucher" class="refund-btn selected"
        title="No additional fees occur for this voucher">
        Voucher
      </button>

      <button id="payout-btn" data-value="payout" class="refund-btn"
        title="Fees cannot be refunded">
        Payout
      </button>

    </div>

    <div id="refund-description" style="margin-top:10px;font-size:13px;color:#555;">
      ${refundContent}
    </div>

    <style>
      #refund-wrapper {
        display: flex;
        width: 100%;
        gap: 10px;
        margin-top: 12px;
      }

      .refund-btn {
        flex: 0 0 30%;
        padding: 5px 0;
        border-radius: 6px;
        border: 1px solid transparent;
        background: #EAEAEA;
        cursor: pointer;
        font-weight: 600;
        transition: background 0.2s ease;
      }

      .refund-btn:focus {
        outline: none;
        box-shadow: none;
      }

      .refund-btn.selected {
        background-color: #009688;
        color: white;
      }
    </style>
  `;
                    body.appendChild(wrapper);
                    const voucher = wrapper.querySelector('#voucher-btn');
                    const payout = wrapper.querySelector('#payout-btn');
                    const description = wrapper.querySelector('#refund-description');
                    voucher.onclick = () => {
                        refundType = 'voucher';
                        refundContent =
                            'Der Gast erhält einen Wertgutschein im Gegenwert der/des gekauften Tickets. Es fallen dafür keine Gebühren an.';
                        voucher.classList.add('selected');
                        payout.classList.remove('selected');
                        description.innerText = refundContent;
                    };
                    payout.onclick = () => {
                        refundType = 'payout';
                        refundContent =
                            'Wir erstatten dem Gast seinen kompletten Betrag entsprechend seiner Zahlweise. Die berechneten Zahlungsgebühren können nicht mehr erstattet werden.';
                        payout.classList.add('selected');
                        voucher.classList.remove('selected');
                        description.innerText = refundContent;
                    };
                }, 0);
            }
            modalRef.result.then((result) => {
                if (result === 'ok') {
                    refundType = !voucherSettingsExists ? 'payout' : refundType;
                    this.eventService.cancelOrder(orderId, refundType).subscribe(() => {
                        this.snackBar.open('Status wurde erfolgreich geändert', '', {
                            duration: 2000,
                            panelClass: ['snackbar-success']
                        });
                        this.getTransactions();
                    }, err => {
                        this.snackBar.open(err.error.msg, '', {
                            duration: 2000,
                            panelClass: ['snackbar-error']
                        });
                    });
                }
            }, () => { });
        });
    }
    showAddress(event, order) {
        event.target.parentElement.parentElement.blur();
        const modalRef = this.modalService.open(ConfirmModalComponent);
        modalRef.componentInstance.title = 'Details';
        const addressDetails = '<div>' +
            (order.email || '') +
            '<br>' +
            (order.firstName + ' ' + order.lastName || '') +
            '<br>' +
            (order.street || '') +
            '<br>' +
            (order.zipcode || '') +
            '<br>' +
            (order.city || '') +
            '<br> Phone no:- ' +
            (order.phone || '') +
            '</div>';
        modalRef.componentInstance.message = addressDetails;
        modalRef.componentInstance.showInfo = false;
        modalRef.componentInstance.buttonText = 'Ja';
        modalRef.result.then((result) => {
            if (result === 'ok') {
            }
        }, () => { });
    }
    filterAmountStatus(filterVal = '') {
        this.amountFilter = filterVal;
        this.getTransactions(false);
    }
    prepareTicketPdf(code) {
        this.eventService.prepareTicketPdf(code).subscribe((res) => {
            const blobdata = new Blob([new Uint8Array(res.data)], { type: 'application/pdf' });
            var fileURL = window.URL.createObjectURL(blobdata);
            window.open(fileURL);
        }, err => {
            const errMsg = err && err.error.msg ? err.error.msg : 'Something went wrong.';
            this.snackBar.open(errMsg, '', {
                duration: 2000,
                panelClass: ['snackbar-error']
            });
        });
    }
    moveTickets(data) {
        const modalRef = this.modalService.open(MoveTicketDatesComponent, { windowClass: 'onboarding-modal' });
        modalRef.componentInstance.ticketInfo = data;
        modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry) => {
            const snackBarRef = this.snackBar.open('Ticket moved successfully.', 'Ok', {
                duration: 3000,
                panelClass: ['snackbar-success']
            });
            this.getTransactions(false);
            modalRef.close();
        });
    }
    getAllEvents() {
        this.eventService.getEvents().subscribe((events) => {
            if (!Array.isArray(events)) {
                this.allEvents = [];
                return;
            }
            this.allEvents = [...events].sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
        });
    }
    clearDate(event) {
        event.stopPropagation();
        this.filter.eventDate = null;
        this.getTransactions(false);
    }
    sendReceipt(order) {
        console.log(order);
        const modalRef = this.modalService.open(ChangeBuyerAddressComponent, { windowClass: 'onboarding-modal' });
        order.name = order.firstName + ' ' + order.lastName;
        order.zipCode = order.zipcode;
        order.company = order.companyName;
        modalRef.componentInstance.order = order;
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            const name = receivedEntry.name.split(' ');
            order.firstName = name[0];
            order.lastName = name.slice(1).join(' ');
            order.street = receivedEntry.street;
            order.zipcode = receivedEntry.zipCode;
            order.city = receivedEntry.city;
            order.companyName = receivedEntry.company;
            order.email = receivedEntry.email;
            this.eventService.sendTicketReceipt(order).subscribe((result) => {
                const index = this.ticketOrders.findIndex((x) => x.id === order.id);
                if (this.ticketOrders[index]) {
                    this.ticketOrders[index] = order;
                }
                this.ticketOrders = [...this.ticketOrders];
                this.snackBar.open('Quittung erfolgreich gesendet.', '', {
                    duration: 2000,
                    panelClass: ['snackbar-success']
                });
            }, (err) => {
                console.error(55, err);
                this.snackBar.open('Something went wrong.', '', {
                    duration: 2000,
                    panelClass: ['snackbar-error']
                });
            });
        });
    }
    accountingTicketPDF(type) {
        this.loadingAccountingPDF = true;
        this.eventService.accountingTicketPDF(this.dates.from, this.dates.to, this.amountFilter, this.filter).subscribe((res) => {
            const blobdata = new Blob([new Uint8Array(res.data)], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blobdata);
            link.download = 'accounting-ticket';
            document.body.append(link);
            link.click();
            link.remove();
            this.loadingAccountingPDF = false;
            this.snackBar.open('PDF is generated successfully.', '', {
                duration: 2000,
                panelClass: ['snackbar-success']
            });
        }, err => {
            this.loadingAccountingPDF = false;
            const errMsg = err && err.error.msg ? err.error.msg : 'Something went wrong.';
            this.snackBar.open(errMsg, '', {
                duration: 2000,
                panelClass: ['snackbar-error']
            });
        });
    }
    downloadTicketPdf(row) {
        this.eventService
            .getTicketsForPayment(row.paymentId, row.tickets && row.tickets[0].dateId ? row.tickets[0].dateId : '')
            .subscribe((res) => {
            const file = res.tickets[0].fileData;
            console.log(file);
            const blobdata = new Blob([new Uint8Array(file.data)], { type: 'application/pdf' });
            var fileURL = window.URL.createObjectURL(blobdata);
            window.open(fileURL);
        }, err => {
            const errMsg = err && err.error.msg ? err.error.msg : 'Something went wrong.';
            this.snackBar.open(errMsg, '', {
                duration: 2000,
                panelClass: ['snackbar-error']
            });
        });
    }
    isWithin60Days(createdAt) {
        const purchaseDate = new Date(createdAt);
        const currentDate = new Date();
        const diffInDays = (currentDate.getTime() - purchaseDate.getTime()) / (1000 * 60 * 60 * 24);
        return diffInDays <= 60;
    }
}
